import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { AuthServiceService } from "../service/auth-service.service";
import { SharedService } from "../shared/shared.service";
import { Router } from "@angular/router";
import {
  DialogAction,
  ActionMessage
} from "../../shared/enum/dialog-action.enum";
@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.css"]
})
export class HomeComponent implements OnInit {
  isLoaded: boolean = true;
  showAppointmentBooking: boolean = false;
  Header: string = "";
  showDialog: boolean = false;
  selectedPage: string;
  isPrompt: boolean = false;
  messageDialog: string = "";
  action: string = "";
  authService: AuthServiceService;
  router: Router;
  showEditPatient: boolean;
  showMedicalHistory: boolean;
  showOverlay: boolean;
  showDiagnosis: boolean = false;
  showPaidModal = false;
  payment = 0;
  transactionid = "";
  data: any;
  secondData: any;
  thirdData: any;
  dialogData: any;
  dob: any = {};
  showOverlayx: boolean = false;
  constructor(
    authorizationService: AuthServiceService,
    route: Router,
    private _sharedService: SharedService
  ) {
    this.authService = authorizationService;
    this.router = route;

    _sharedService.changeEmitted$.subscribe(text => {
      setTimeout(() => {
        this.isLoaded = text;
      }, 700);
    });
    _sharedService.dialogEmitted$.subscribe(text => {
      this.showDialog = text.change;
      this.messageDialog = text.message;
      this.Header = text.header;
      this.isPrompt = text.isPrompt;
      this.action = text.type;
      this.selectedPage = text.page;
      this.dialogData = text.data;
    });
    _sharedService.overlayEmitted$.subscribe(text => {
      if (text.module === "PATIENT") {
        if (text.type === "Edit") {
          this.showEditPatient = true;
          if (text.data.PatientDOB !== null && text.data.PatientDOB !== "") {
            let db = text.data.PatientDOB.split("-");
            this.dob = {
              date: {
                year: parseInt(db[2]),
                month: parseInt(db[1]),
                day: parseInt(db[0])
              }
            };
          }
        } else if (text.type === "Appointment") {
          this.showAppointmentBooking = true;
        } else if (text.type === "Diagnosis") {
          this.showDiagnosis = true;
        } else {
          this.showMedicalHistory = true;
        }
      }
      if (text.module === "USER") {
        if (text.type === "Appointment") {
          this.showAppointmentBooking = true;
          this.thirdData = text.thirdData;
        } else if (text.type === "PaidTrans") {
          this.showPaidModal = true;
          this.data = text;
          this.payment = 0;
          this.transactionid = "";
        }
      }
      this.showOverlay = text.isShow;
      this.data = text.data;
      this.secondData = text.secondData;
    });
  }
  yes(): void {
    this.showDialog = false;
    let page: string = this.selectedPage;
    if (this.action === DialogAction.DELETE.toString()) {
      this._sharedService.yes({
        Action: DialogAction.DELETE.toString(),
        Response: DialogAction.YES.toString(),
        Page: page,
        Data: this.dialogData
      });
    } else if (this.action === DialogAction.COPY.toString()) {
      this._sharedService.yes({
        Action: DialogAction.COPY.toString(),
        Response: DialogAction.YES.toString(),
        Page: page,
        Data: this.dialogData
      });
    } else {
      this._sharedService.yes({
        Action: DialogAction.CANCEL.toString(),
        Response: DialogAction.YES.toString(),
        Page: page,
        Data: this.dialogData
      });
    }
  }
  no(): void {
    this.showDialog = false;
    /* if(this.action === DialogAction.DELETE.toString()) {
       this._sharedService.no({Action : DialogAction.DELETE.toString(), Response : DialogAction.NO.toString() });
    } else {
       this._sharedService.no({Action : DialogAction.CANCEL.toString(), Response : DialogAction.NO.toString() });
    } */
  }

  ngOnInit() {
    $("body").addClass("theme-cyan");

    //this.loadScript('assets/bundles/libscripts.bundle.js');
    //this.loadScript('assets/bundles/vendorscripts.bundle.js');
    //this.loadScript('assets/bundles/mainscripts.bundle.js');
  }
  logout() {
    if (this.authService.logout()) {
      this.router.navigate(["login"]);
    }
  }
  cancelDialog(res) {
    this.showOverlay = res;
    this.showEditPatient = res;
    this.showMedicalHistory = res;
    this.showAppointmentBooking = res;
    this.showDiagnosis = res;
    this.showPaidModal = res;
  }
  closePopup() {
    $("modal fade").removeClass("in show");
  }
  closeDialog(res) {
    this.showOverlay = false;
    if (this.showEditPatient) {
      this._sharedService.profileedit({ data: this.data });
    }
    this.showEditPatient = false;
    this.showMedicalHistory = false;
    if (this.showPaidModal) {
      this._sharedService.setTransactionAction({
        amount: this.payment,
        transactionId: this.transactionid,
        data: this.data
      });
    }
    this.showPaidModal = false;
    if (this.showAppointmentBooking) {
      this._sharedService.booking({});
    }
    this.showAppointmentBooking = false;
    if (this.showDiagnosis) {
      this._sharedService.updatePrescription({ data: this.data });
      this.cancelDialog(false);
    }
  }
  public loadScript(url) {
    let node = document.createElement("script");
    node.src = url;
    node.type = "text/javascript";
    document.getElementsByTagName("head")[0].appendChild(node);
  }

  patToUser() {
    this.closeDialog(true);
  }
}



// WEBPACK FOOTER //
// ./src/app/component/home/home.component.ts